import { helpArticles } from '~/utils/helpArticles';
import CalendlyLogo from '../logos/calendly.svg';
import ClickUpLogo from '../logos/clickup.svg';
import GoogleChatLogo from '../logos/google-chat.svg';
import GoogleFormsLogo from '../logos/google-forms.svg';
import MicrosoftTeamsLogo from '../logos/microsoft-teams.svg';
import NotionLogo from '../logos/notion.svg';
import SurveyMonkeyLogo from '../logos/surveymonkey.svg';
import TaxDomeLogo from '../logos/taxdome.svg';
import TypeformLogo from '../logos/typeform.svg';
import ZohoCrmLogo from '../logos/zoho.svg';
const NOTION_CLIENT_DB_TEMPLATE_URL = 'https://carpal-poinsettia-676.notion.site/Client-information-template-Index-08bc6571492c83fb8cc981fcbe5ecdd4';
const microsoftTeams = {
    key: 'microsoft-teams',
    i18nKey: 'microsoftTeams',
    biConnectName: 'connect_microsoft_teams_via_zapier',
    Logo: MicrosoftTeamsLogo,
    descriptionLinks: {
        readMore: helpArticles.microsoftTeamsZapier()
    },
    templates: [
        {
            key: 'proposalSent',
            url: 'https://zapier.com/templates/details/send-channel-messages-in-teams-when-new-proposals-are-sent-in-anchor-a94365?secret=MTp0ZW1wbGF0ZTpkU21BcUptRm5ZV0JzWUtJc2ZGRTBtYkhUZkEwZ096WXpkY29Vc2pCOGEwOjMxNWg0eg'
        },
        {
            key: 'proposalReviewed',
            url: 'https://zapier.com/templates/details/send-channel-messages-in-teams-when-proposals-are-reviewed-in-anchor-e5139c?secret=MTp0ZW1wbGF0ZTo0YWNESGxuUmhaZFoycTVTU2RBOXNiWUhGa2o1MjFoQmM2ajVfRWwtdTZFOmNvZjRocw'
        },
        {
            key: 'proposalApproved',
            url: 'https://zapier.com/templates/details/send-channel-messages-in-teams-when-proposals-are-approved-in-anchor-b1fb78?secret=MTp0ZW1wbGF0ZTplRG9Xd0QxZmVHem1EcFhOVE05Q0dQZ0tUWk5JN2RuTkdRTlVzRXQxMFNROnV1N2E5cw'
        },
        {
            key: 'amendmentApproved',
            url: 'https://zapier.com/templates/details/send-channel-messages-in-teams-when-amendment-are-approved-in-anchor-73083d?secret=MTp0ZW1wbGF0ZTp5azMtbTVhTERSMDl4LWhidENGYUxfRWhrdmZ5OFpuUjFUTUlnTXBTdjVVOnhjYnVsNg'
        },
        {
            key: 'invoiceIssued',
            url: 'https://zapier.com/templates/details/send-microsoft-teams-channel-messages-for-newly-issued-anchor-invoices-02e95d?secret=MTp0ZW1wbGF0ZTpnbUNqTVFlemJLNVRRVUY2QXM0bWdTYXhrVFZGLUd0RWMtTU9XU29tZlE0OjNtMm85MA'
        },
        {
            key: 'invoicePaid',
            url: 'https://zapier.com/templates/details/send-channel-messages-in-teams-when-invoices-are-paid-in-anchor-5f7629?secret=MTp0ZW1wbGF0ZTpJeENIYWQ5UWZ6bTdDWFFfYWxUX0VnaVcteGJvaEljS3ZWdDFGc2lQOE9JOmI5MWR5Zg'
        },
        {
            key: 'invoiceFailed',
            url: 'https://zapier.com/templates/details/send-channel-messages-in-teams-when-an-invoice-fails-in-anchor-705723?secret=MTp0ZW1wbGF0ZTpwVU1NX3ViYldqc3RmSmpqMmVMQjIyMW1QODY2NEo2ZTBLeEhiemRGdF9ROnFid2x6MQ'
        },
        {
            key: 'payoutDeposited',
            url: 'https://zapier.com/templates/details/send-channel-messages-in-teams-when-receiving-a-payout-in-anchor-b07372?secret=MTp0ZW1wbGF0ZTpqWUs4U1BBY3ZsLW42NExDVjZyY3J5c2ppWm9DVVoycUp6X0lTWDdjRUxJOjRkMWg3ZA'
        }
    ]
};
const googleChat = {
    key: 'google-chat',
    i18nKey: 'googleChat',
    biConnectName: 'connect_google_chat_via_zapier',
    Logo: GoogleChatLogo,
    descriptionLinks: {
        readMore: helpArticles.googleChatZapier()
    },
    templates: [
        {
            key: 'proposalSent',
            url: 'https://zapier.com/templates/details/send-google-chat-messages-when-new-proposals-are-sent-in-anchor-f9944a?secret=MTp0ZW1wbGF0ZTpGRzhTNjhteWc2UEhnYkVqTkExN0pmOEszYXdQZlRFUWJTREtfR1o4cnBJOjg3ODI2eA'
        },
        {
            key: 'proposalReviewed',
            url: 'https://zapier.com/templates/details/send-google-chat-messages-when-an-anchor-proposal-is-reviewed-c3e196?secret=MTp0ZW1wbGF0ZTo3OUxfSkNvNkUtejg0MXVVQzdORWpxU3Qyd0tjWjBMb1d4VGRSeHUwRVE4OnZiYjV4Yg'
        },
        {
            key: 'proposalApproved',
            url: 'https://zapier.com/templates/details/post-a-message-in-google-chat-when-a-new-proposal-is-approved-24575a?secret=MTp0ZW1wbGF0ZTpLMzl5SGZOaXlKU09HaWFQX1ZKTlRndmlCZmNvTk8yNmc2LXBQVDJNVUU0OjF1ams0Ng'
        },
        {
            key: 'amendmentApproved',
            url: 'https://zapier.com/templates/details/send-google-chat-messages-for-newly-approved-agreement-amendments-in-anchor-5e1d4f?secret=MTp0ZW1wbGF0ZToyclVlU2dRaEhaMzV5ZTVNUVkxMFFZZHRjRTVBc3JHVUxDSU5JVGxtNU9zOnlqNms3OQ'
        },
        {
            key: 'invoiceIssued',
            url: 'https://zapier.com/templates/details/send-google-chat-messages-for-newly-issued-anchor-invoices-aad0a7?secret=MTp0ZW1wbGF0ZTpRM2RDcEgzZjYzMVltYzMwM1BtR3VEX1pnVlItSWdvMGhFamV0aE5fd05jOmt6NXplZg'
        },
        {
            key: 'invoicePaid',
            url: 'https://zapier.com/templates/details/send-google-chat-messages-for-paid-invoices-in-anchor-07ec85?secret=MTp0ZW1wbGF0ZTpiYXdBeXNqUmNsQU5sQzdzdnRkQXJ5TWZQNUlLRFVCRWtFMWF0MXY2NFIwOjRtY3VqZA'
        },
        {
            key: 'invoiceFailed',
            url: 'https://zapier.com/templates/details/notify-google-chat-of-failed-invoice-payments-in-anchor-0f7e0b?secret=MTp0ZW1wbGF0ZTpDekozc3oyYTM4VjFUcEkzTnhZRXdMbGJyQ2libHZYN0NfdTAyRUJzU1hzOm1rbnJ4dA'
        },
        {
            key: 'payoutDeposited',
            url: 'https://zapier.com/templates/details/send-google-chat-messages-for-deposited-payouts-in-anchor-ccf175?secret=MTp0ZW1wbGF0ZTpnSjYxb210QkFDVHktdEFGUGM2TGxYT2xqVi1PS1FaN3JLNzFOOGkzcm1ROjZwcGpncQ'
        }
    ]
};
const clickUp = {
    key: 'clickup',
    i18nKey: 'clickUp',
    biConnectName: 'connect_clickup_via_zapier',
    Logo: ClickUpLogo,
    descriptionLinks: {
        instructions: helpArticles.clickUpZapier()
    },
    templates: [
        {
            key: 'createSpaceAndTasks',
            url: 'https://zapier.com/templates/details/anchor-clickup-automatically-create-spacetasks-on-proposal-approval-9f51aa?secret=MTp0ZW1wbGF0ZTpNQ2xkX2Y3ZDE1WlRIQWNVUVBaeDdpZkFnNXpKREZVN2Q0VGFBT0dPV3lFOmdpMTdodg'
        }
    ]
};
const notion = {
    key: 'notion',
    i18nKey: 'notion',
    biConnectName: 'connect_notion_via_zapier',
    Logo: NotionLogo,
    descriptionLinks: {
        notionTemplate: NOTION_CLIENT_DB_TEMPLATE_URL,
        instructions: helpArticles.notionZapier()
    },
    templates: [
        {
            key: 'createClient',
            url: 'https://zapier.com/templates/details/create-a-client-in-notion-client-db-when-a-proposal-is-approved-in-anchor-85a6fa?secret=MTp0ZW1wbGF0ZTp0dTNLbEl0bXVJRFZWYW5heWNGblRMcmwtdjJ3MFBIdFNvTlROMDZUcmVnOm5ybzdhYQ'
        },
        {
            key: 'createInvoice',
            url: 'https://zapier.com/templates/details/create-an-invoice-and-link-client-in-notion-from-an-anchor-invoice-363f41?secret=MTp0ZW1wbGF0ZTpiZHVtWXZqSzBZT3AtTVJVZnV6Y2U4X1VrS1hPaS1hZjQ0NHRFWU5pb2xnOjYzcndlbA'
        },
        {
            key: 'markInvoicePaid',
            url: 'https://zapier.com/templates/details/mark-invoice-in-notion-as-paid-when-paid-in-anchor-a114ad?secret=MTp0ZW1wbGF0ZTp3NUc2WVJ4Ry1CeUxJdUUtWEVNMFlxR1JPd0lJWkZ0RTVBa19xZ2s4SXpjOnBkbWI2ZQ'
        }
    ]
};
const taxDome = {
    key: 'taxdome',
    i18nKey: 'taxDome',
    biConnectName: 'connect_taxdome_via_zapier',
    Logo: TaxDomeLogo,
    descriptionLinks: {
        readMore: helpArticles.taxDomeZapier()
    },
    templates: [
        {
            key: 'createAccountAndContact',
            url: 'https://zapier.com/templates/details/create-an-account-and-contact-in-taxdome-on-a-signed-anchor-proposal-a9e37c?secret=MTp0ZW1wbGF0ZTp5THUyUFRPT0RLUklOdDF5LWw5T2J2X3lrc2FZU09XbWRMUk1IZmY0Nmx3OmdiaDJ6Zg'
        }
    ]
};
const zohoCrm = {
    key: 'zoho-crm',
    i18nKey: 'zohoCrm',
    biConnectName: 'connect_zoho_crm_via_zapier',
    Logo: ZohoCrmLogo,
    descriptionLinks: {
        readMore: helpArticles.zohoCrmZapier()
    },
    templates: [
        {
            key: 'contactFromContact',
            url: 'https://zapier.com/templates/details/zoho-anchor-create-contact-on-new-contact-b5ec09?secret=MTp0ZW1wbGF0ZTpNWW1feVZmS1d2YlRESXdGbXlFUHNHTE5wSEJoTHpOMUJuSkU4VVhIWVVBOndreXM4bw'
        },
        {
            key: 'contactFromLead',
            url: 'https://zapier.com/templates/details/zoho-anchor-create-contact-on-new-lead-d1e834?secret=MTp0ZW1wbGF0ZTpMVnMwS2IzamUwLUtab2Q4TElwRkhyRUptN05PU0JvUWdhR1ZGTDl3LWZBOnFveXAyeQ'
        }
    ]
};
const typeform = {
    key: 'typeform',
    i18nKey: 'typeform',
    biConnectName: 'connect_typeform_via_zapier',
    Logo: TypeformLogo,
    descriptionLinks: {
        readMore: helpArticles.typeformZapier()
    },
    templates: [
        {
            key: 'createContact',
            url: 'https://zapier.com/templates/details/create-a-new-contact-in-anchor-from-a-typeform-entry-b797b8?secret=MTp0ZW1wbGF0ZTptbl9LajJ0U0tleHVXSUlEejNjQTBRYmZrcjNSM0tzZTJlYXB2YTQ1bWZROmM0d3FxNQ'
        },
        {
            key: 'createProposal',
            url: 'https://zapier.com/templates/details/create-and-send-a-proposal-from-new-typeform-responses-341fcb?secret=MTp0ZW1wbGF0ZTpiZE5yRVREU2VqaXU3ZG8wTmRWeEJBM2pfdGU2Z0ZBOS1yX2VNR0R0MWI0OmkyMHhiZg'
        }
    ]
};
const surveyMonkey = {
    key: 'surveymonkey',
    i18nKey: 'surveyMonkey',
    biConnectName: 'connect_surveymonkey_via_zapier',
    Logo: SurveyMonkeyLogo,
    descriptionLinks: {
        readMore: helpArticles.surveyMonkeyZapier()
    },
    templates: [
        {
            key: 'createContact',
            url: 'https://zapier.com/templates/details/create-a-new-contact-in-anchor-from-a-surveymonkey-entry-1409c5?secret=MTp0ZW1wbGF0ZTpVVUgxN0xfN1RTWnJpZVdoMXhzWW9OcGlxY2J0Y2RnbmVvbEpYTjBlVDNzOnk2NDQwNA'
        },
        {
            key: 'createProposal',
            url: 'https://zapier.com/templates/details/create-and-send-a-proposal-from-new-surveymonkey-responses-9fb637?secret=MTp0ZW1wbGF0ZTotNlplb0ZTd2EzMU1uaXlEdklBdzY2ZXA0R3ROQlNRNHJuUEdNNWVaUThjOm44bTJ2NA'
        }
    ]
};
const googleForms = {
    key: 'google-forms',
    i18nKey: 'googleForms',
    biConnectName: 'connect_google_forms_via_zapier',
    Logo: GoogleFormsLogo,
    descriptionLinks: {
        readMore: helpArticles.googleFormsZapier()
    },
    templates: [
        {
            key: 'createContact',
            url: 'https://zapier.com/templates/details/create-a-new-contact-in-anchor-from-a-google-forms-entry-7a789c?secret=MTp0ZW1wbGF0ZTpjNEdZSUd2Q1pKWGV6NjNFbmw3UlNqX2piNDdIM1hFdG9hRTJzTzU4QUU0Om9ya2N6ag'
        },
        {
            key: 'createProposal',
            url: 'https://zapier.com/templates/details/create-and-send-a-proposal-from-new-google-forms-responses-3a7599?secret=MTp0ZW1wbGF0ZTpiWkZrLU1ia1cwU3lYMlYxdUJkT0ZBdWtERzZSMFpBYVFMRHFYN3FPT09ZOmJzdXI5cQ'
        }
    ]
};
const calendly = {
    key: 'calendly',
    i18nKey: 'calendly',
    biConnectName: 'connect_calendly_via_zapier',
    Logo: CalendlyLogo,
    descriptionLinks: {
        readMore: helpArticles.calendlyZapier()
    },
    templates: [
        {
            key: 'createContact',
            url: 'https://zapier.com/templates/details/calendly-create-anchor-contact-on-discovery-call-scheduled-9767bd?secret=MTp0ZW1wbGF0ZTpvMDVnMzlOVkhIV0JQSmpOTFFBZkY5WUs5ZkZYOHpzcms5WG9wOV9MVjZFOjBkYnF5bw'
        }
    ]
};
export const zapierTemplateIntegrationsByGroup = {
    communications: [
        microsoftTeams,
        googleChat
    ],
    practiceManagement: [
        clickUp,
        notion,
        taxDome
    ],
    crm: [
        zohoCrm
    ],
    forms: [
        typeform,
        surveyMonkey,
        googleForms
    ],
    scheduling: [
        calendly
    ]
};
export const zapierTemplateIntegrations = Object.values(zapierTemplateIntegrationsByGroup).flat();
export const zapierTemplateIntegrationsByKey = Object.fromEntries(zapierTemplateIntegrations.map((integration)=>[
        integration.key,
        integration
    ]));
